module.exports = __webpack_public_path__ + "prod/1.2.3/img/ht.016c948b.png";